import { InvoiceStatusEnum } from 'domains-billing-types';

import { canMarkInvoiceAsBilled } from './markInvoiceAsBilledEligibility';
import { isManagedInvoiceStatus } from './invoiceStatusModel';

export const MARK_AS_PAID_ACTION_ID = 'invoiceAction-markAsPaid';
export const MARK_AS_BILLED_ACTION_ID = 'invoiceAction-markAsBilled';

export function getInvoiceRowActionAvailability({
  actionId,
  status,
  invoiceDate,
  hasPermission,
  isBilledStatusEnabled,
}: {
  actionId?: string;
  status: string;
  invoiceDate?: Date | string | null;
  hasPermission: boolean;
  isBilledStatusEnabled: boolean;
}): {
  isVisible: boolean;
  isDisabled?: boolean;
  disabledReasonKey?: string;
} {
  if (actionId === MARK_AS_BILLED_ACTION_ID) {
    if (!isBilledStatusEnabled) return { isVisible: false };

    if (hasPermission && status === InvoiceStatusEnum.BILLED) {
      return { isVisible: true, isDisabled: true };
    }

    const { isVisible, isEnabled } = canMarkInvoiceAsBilled({
      status,
      invoiceDate,
      hasPermission,
    });

    if (!isVisible) return { isVisible };

    return {
      isVisible,
      isDisabled: !isEnabled,
      ...(!isEnabled && {
        disabledReasonKey: 'abp.invoice.markAsBilledNotYetAvailable',
      }),
    };
  }

  const isMarkAsPaidHidden =
    actionId === MARK_AS_PAID_ACTION_ID &&
    isBilledStatusEnabled &&
    isManagedInvoiceStatus(status, true);

  return { isVisible: !isMarkAsPaidHidden };
}
